export enum BrandingProperties {
  ProfileImage = 'profileImage',
  BannerImage = 'bannerImage',
  WatermarkImage = 'watermarkImage',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Profile = 'profile',
  ReleaseActions = 'releaseActions',
  PendingBranding = 'pendingBranding',
}
export enum BrandingMetaProperties {
  ProfileImageId = 'ProfileImage-id',
  ProfileImageVersion = 'ProfileImage-version',
  ProfileId = 'Profile-id',
  ProfileVersion = 'Profile-version',
  ReleaseActionsId = 'ReleaseActions-id',
  ReleaseActionsVersion = 'ReleaseActions-version',
  PendingBrandingId = 'PendingBranding-id',
  PendingBrandingVersion = 'PendingBranding-version',
}
